<template lang="pug">
    div
        template(v-if="$device.isSmall")
            Overlay(
                v-show="activeOverlay === 'facetMenu'"
                uniqueKey="facetMenu"
                :enableDarkMode="true"
                @close="close"
            )
                template(#header)
                    div(class="flex items-center")
                        div(class="title") Filter
                        div(class="font-normal text-sm pl-1")
                            | (#[SearchStats(class="inline")])

                RefinementSameDayShipping(
                    v-if="catalogData.showSameDayShippingFacet"
                    :isLight="true"
                )

                RefinementCategory(
                    v-if="!catalogData.category.showAsFacet"
                    :level="catalogData.category.facetLevel"
                    :isLight="true"
                    :isCollapsedDefault="true"
                )

                template(v-for="{ facet, text } in catalogData.facets")
                    SearchRefinementList(
                        :attribute="facet"
                        :title="text"
                        :isLight="true"
                        :isCollapsedDefault="true"
                        :showHightlightWhenRefined="true"
                        :showSelectedRefinementsWhenCollapsed="true"
                    )

                template(#footer)
                    div(class="flex")
                        BaseButton(
                            color="GRAY"
                            @click.native="clearRefinements"
                            class="w-full mr-3"
                        ) Clear All
                        BaseButton(
                            @click.native="close"
                            class="w-full ml-3"
                        ) Done

        template(v-else)
            RefinementSameDayShipping(v-if="catalogData.showSameDayShippingFacet")

            RefinementCategory(
                v-if="!catalogData.category.showAsFacet"
                :level="catalogData.category.facetLevel"
            )

            template(v-for="{ facet, text } in catalogData.facets")
                SearchRefinementList(
                    :attribute="facet"
                    :title="text"
                    @refinementClicked="trackRefinement"
                )

</template>

<script>
import SearchComponent from '@/components/search/component'
import SearchRefinementList from '@/components/search/refinementList'
import SearchStats from '@/components/search/stats'
import BaseButton from '@/components/baseButton'
import RefinementCategory from './refinementCategory'
import RefinementSameDayShipping from './sameDayShipping/facetRefinement'
const Overlay = () => import(/* webpackChunkName: "overlay" */ '@/components/overlay')

export default {
    name: 'Refinements',
    components: {
        SearchRefinementList,
        SearchStats,
        BaseButton,
        Overlay,
        RefinementCategory,
        RefinementSameDayShipping,
    },
    extends: SearchComponent,
    computed: {
        activeOverlay() {
            return this.$overlay.state.activeOverlay
        },
        catalogData() {
            return this.$store.state.catalog.data
        },
    },
    mounted() {
        this.$overlay.registerUrlKey('facetMenu')
    },
    methods: {
        trackRefinement(data) {
            const { title, value } = data

            this.$uiEvents.$emit('facetClicked', {
                facet: title.toLowerCase(),
                value: value.toLowerCase(),
                route: this.$route,
            })
        },
        close() {
            this.$overlay.hide()
        },
        clearRefinements() {
            this.$searchContext.clearRefinements()

            // Right now we remove mod from the url manually here. if we wanted to make sure we don't
            // close the menu when we clear we would need to make sure we leave it in the query string.
            const route = {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                },
                query: {
                    ...this.$searchContext.createRouteQuery(),
                },
            }

            this.$push.to(route)
        },
    },
}
</script>
